import React from "react";

/**
 * Wraps console view content with consistent loading and error states.
 * Renders children only when !loading && !error.
 */
export default function ConsoleViewShell({ loading, error, loadingLabel = "Loading…", children }) {
  if (loading) {
    return (
      <div className="console-view">
        <p className="console-muted-text">{loadingLabel}</p>
      </div>
    );
  }
  if (error) {
    return (
      <div className="console-view">
        <p className="console-error-text">{error}</p>
      </div>
    );
  }
  return children;
}
